// frontend/src/components/VistaDetalladaCliente.js
import React, { useEffect, useState, useCallback } from 'react'; // Importar useCallback
import ClienteImpresion from './ClienteImpresion';
import PreviewCancelacionBajaCliente from './PreviewCancelacionBajaCliente';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SelectorReferenciaCliente from './SelectorReferenciaCliente';
import DatosMaestrosService from '../services/datosMaestrosService';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getNivelesEducativos } from '../services/nivelEducativoService';
import { getProvincias } from '../services/provinciaService';
import { getTipoTramites } from '../services/tipoTramiteService';
import { getLocalidadesPorProvincia, getLocalidadesPorDivision } from '../services/localidadService';
import { getDivisionesPorProvincia } from '../services/divisionPrimariaService';
import { getContactosPorCliente, modificarContacto, crearContacto, eliminarContacto } from '../services/contactoService';
import { getClientePorCuil, modificarCliente, eliminarCliente, reactivarCliente, revelarClaves } from '../services/clienteService'; // <--- IMPORTANTE: Importar revelarClaves
import GestionAportes from './GestionAportes';
import RegularidadAporte from './RegularidadAporte';
import ModalAgregarClienteAnses from './anses/ModalAgregarClienteAnses';
import { agregarALista } from '../services/seguimientoExpedientesService';
import { metaTramite, rutaDetalleTramite, rutaIniciarTramite } from '../utils/rutasTramite';
import TarjetaCobrosCliente from './Cobranzas/TarjetaCobrosCliente';
import SeccionLey24476Cliente from './PlanPago/SeccionLey24476Cliente';
import {
    Typography,
    Box,
    Paper,
    Button,
    CircularProgress,
    Alert,
    TextField,
    Checkbox,
    MenuItem,
    FormControlLabel,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Stack,
    Snackbar,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Select,
    Grid,
    Tooltip,
    Chip,
    IconButton,      // <--- Nuevo
    Divider
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PrintIcon from '@mui/icons-material/Print';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import InfoIcon from '@mui/icons-material/Info';
import VisibilityIcon from '@mui/icons-material/Visibility'; // <--- Icono Ojo
import RestoreIcon from '@mui/icons-material/Restore';
import LockIcon from '@mui/icons-material/Lock'; // <--- Icono Candado
import WarningIcon from '@mui/icons-material/Warning';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import PersonIcon from '@mui/icons-material/Person';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import WhatsAppHeaderButton from './WhatsAppHeaderButton';
import HomeIcon from '@mui/icons-material/Home';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import SchoolIcon from '@mui/icons-material/School';
import LinkIcon from '@mui/icons-material/Link';
import Autocomplete from '@mui/material/Autocomplete';
import NotaComentario from './NotaComentario';
import { useAuth } from '../auth/AuthContext';
import ModalEliminarDefinitivo from './Administracion/ModalEliminarDefinitivo';
import { isTelefonoCordobaValido, normalizeTelefonoForStorage } from '../utils/telefonoCordoba';
import { modificarTramite } from '../services/tramiteService';
import HistorialTurnosCliente from './recepcion/HistorialTurnosCliente';
import { FilasPlanillaCliente } from './Tramite/FilaPlanilla';
import { PlanillaHistoricaCliente } from './PlanillaHistorica/PlanillaHistorica';
import '../style/components/TramitesCliente.css';
import { apellidoNombre } from '../utils/nombrePersona';

const domicilioVacio = () => ({
    calle: '',
    altura: '',
    piso: '',
    departamento: '',
    barrio: '',
    tipo: '',
    localidad: { id: '', localidad: '', provincia: { id: '' } },
    _provinciaId: '',
    _divisionId: '',
    _divisiones: [],
    _localidades: []
});

const limpiarDomicilioParaGuardar = ({ _provinciaId, _divisionId, _divisiones, _localidades, ...d }) => d;

const hijoVacio = () => ({
    nombre: '',
    fechaNacimiento: '',
    tieneAuh: false,
    tieneCud: false,
    esAdoptado: false
});

// Deriva la edad a partir de la fecha de nacimiento (YYYY-MM-DD); sin fecha, sin edad.
const calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento) return '';
    const hoy = new Date();
    const nac = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - nac.getFullYear();
    const m = hoy.getMonth() - nac.getMonth();
    if (m < 0 || (m === 0 && hoy.getDate() < nac.getDate())) edad--;
    return edad >= 0 ? edad : '';
};

// Estilos reutilizables para Acordeones Modernos
const accordionStyle = {
    borderRadius: "12px !important",
    border: "2px solid #e5e7eb",
    boxShadow: "var(--shadow-md)",
    mb: 2, // Margen inferior para separación
    "&:before": { display: "none" }, // Ocultar línea por defecto de MUI
    // NO agregar overflow: 'hidden' acá. Recorta los desplegables absolutos que
    // se abren dentro del acordeón (buscador de cliente referente en
    // SelectorReferenciaCliente y las sugerencias de ComboboxDatosMaestros):
    // un ancestro con overflow oculto recorta a sus descendientes absolutos sin
    // importar el z-index. El redondeo de las esquinas ya lo resuelve el propio
    // borderRadius de accordionSummaryStyle.
    overflow: 'visible'
};

const accordionSummaryStyle = {
    background: "var(--gradient-primary-light)",
    borderBottom: "1px solid #e5e7eb",
    borderRadius: "12px",
    "&.Mui-expanded": {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    }
};

const tituloSeccionStyle = {
    fontWeight: 700,
    color: "#1e3a8a", // Azul oscuro profesional
    display: 'flex',
    alignItems: 'center',
    gap: 1
};

// Componente helper para mostrar datos en modo lectura con estilo
const DatoLectura = ({ label, value, icon }) => (
    <Box sx={{
        p: 1.5,
        borderRadius: 2,
        bgcolor: '#f8fafc',
        border: '1px solid #f1f5f9',
        height: '100%',
        transition: 'all 0.2s',
        '&:hover': {
            bgcolor: '#f1f5f9',
            borderColor: '#e2e8f0'
        }
    }}>
        <Typography variant="caption" sx={{
            color: '#64748b',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            display: 'block',
            mb: 0.5,
            fontSize: '0.7rem'
        }}>
            {label}
        </Typography>
        <Box display="flex" alignItems="center" gap={1}>
            {icon && <Box sx={{ color: '#3b82f6', opacity: 0.8 }}>{icon}</Box>}
            <Typography variant="body1" sx={{ color: '#0f172a', fontWeight: 500, wordBreak: 'break-word' }}>
                {value || '—'}
            </Typography>
        </Box>
    </Box>
);

function VistaDetalladaCliente() {
    const { cuil } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();
    // Borrado definitivo: solo ADMIN/PROGRAMADOR y solo sobre un cliente YA dado de baja. El
    // backend vuelve a validar las dos cosas.
    const [modalEliminarDefinitivo, setModalEliminarDefinitivo] = useState(false);

    const [cliente, setCliente] = useState(null);
    const [loading, setLoading] = useState(true);
    const [niveles, setNiveles] = useState([]);
    const [contactos, setContactos] = useState([]);
    const [error, setError] = useState('');
    const [provincias, setProvincias] = useState([]);
    const [domicilios, setDomicilios] = useState([domicilioVacio()]);
    const [hijos, setHijos] = useState([]);
    const [dialogoConfirmarEliminarHijos, setDialogoConfirmarEliminarHijos] = useState({ open: false, hijos: [], mensaje: '' });
    const [referenciasDisponibles, setReferenciasDisponibles] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [modoImpresion, setModoImpresion] = useState(false);
    const [dialogoEliminar, setDialogoEliminar] = useState({ open: false });
    const [observacionEliminar, setObservacionEliminar] = useState('');
    const [previewBajaCargado, setPreviewBajaCargado] = useState(false);
    const [dialogoReactivar, setDialogoReactivar] = useState({ open: false });
    const [observacionReactivar, setObservacionReactivar] = useState('');

    // --- ESTADOS PARA SEGURIDAD (REVELAR CLAVES) ---
    const [dialogoSeguridad, setDialogoSeguridad] = useState(false);
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [clavesReales, setClavesReales] = useState(null); // Aquí se guardan las desencriptadas
    const [errorPassword, setErrorPassword] = useState('');
    const [conflictDialogOpen, setConflictDialogOpen] = useState(false);
    // -----------------------------------------------

    const [modalAnsesAbierto, setModalAnsesAbierto] = useState(false);
    const handleClienteAgregadoAnses = ({ cuil, clave, prioridad }) => agregarALista(cuil, clave, prioridad);

    const [edad, setEdad] = useState('');
    const [dialogoSeleccionArea, setDialogoSeleccionArea] = useState(false);
    const [dialogoNoDisponible, setDialogoNoDisponible] = useState(false);
    const [areaSeleccionada, setAreaSeleccionada] = useState('');
    const [tiposTramite, setTiposTramite] = useState([]);
    const [etiquetaEditId, setEtiquetaEditId] = useState(null);
    const [etiquetaDraft, setEtiquetaDraft] = useState('');
    const [guardandoEtiqueta, setGuardandoEtiqueta] = useState(false);

    // --- LÓGICA DE CARGA DE DATOS CENTRALIZADA ---
    const cargarDatosCompletos = useCallback(async () => {
        setLoading(true);
        try {
            const clienteData = await getClientePorCuil(cuil);

            const clienteNormalizado = {
                ...clienteData,
                telefonoPropio: normalizeTelefonoForStorage(clienteData.telefonoPropio),
                clave: clienteData.clave ?? { idClave: null, claveAfip: '', claveSs: '', claveCidi: '' },
                domicilio: clienteData.domicilios?.[0] ?? clienteData.domicilio ?? null
            };

            setCliente(clienteNormalizado);
            setHijos(clienteData.hijos ?? []);

            // Inicializar domicilios con geografía pre-cargada
            const domiciliosData = clienteData.domicilios?.length
                ? clienteData.domicilios
                : (clienteData.domicilio ? [clienteData.domicilio] : []);

            const domiciliosConGeo = await Promise.all(domiciliosData.map(async (dom) => {
                const provinciaId = dom.localidad?.provincia?.id || '';
                const divisionId = dom.localidad?.division?.id || '';
                let divisiones = [], localidades = [];
                if (provinciaId) {
                    try {
                        [divisiones, localidades] = await Promise.all([
                            getDivisionesPorProvincia(provinciaId),
                            divisionId
                                ? getLocalidadesPorDivision(divisionId)
                                : getLocalidadesPorProvincia(provinciaId)
                        ]);
                    } catch { /* usa vacíos */ }
                }
                return {
                    ...dom,
                    _provinciaId: provinciaId,
                    _divisionId: divisionId,
                    _divisiones: divisiones,
                    _localidades: localidades
                };
            }));
            setDomicilios(domiciliosConGeo.length ? domiciliosConGeo : [domicilioVacio()]);

            const contactosData = await getContactosPorCliente(cuil);
            setContactos(contactosData.map((contacto) => ({
                ...contacto,
                nroTelefono: normalizeTelefonoForStorage(contacto.nroTelefono)
            })));
        } catch (e) {
            setError('No se pudo cargar el cliente o sus contactos. Verifique el CUIL e intente de nuevo.');
        } finally {
            setLoading(false);
        }
    }, [cuil]);


    useEffect(() => {
        if (cliente && cliente.fechaNacimiento) {
            const hoy = new Date();
            const nacimiento = new Date(cliente.fechaNacimiento);
            let edadCalculada = hoy.getFullYear() - nacimiento.getFullYear();
            const m = hoy.getMonth() - nacimiento.getMonth();
            if (m < 0 || (m === 0 && hoy.getDate() < nacimiento.getDate())) {
                edadCalculada--;
            }
            setEdad(edadCalculada);
        } else {
            setEdad('');
        }
    }, [cliente]);

    useEffect(() => {
        cargarDatosCompletos();
    }, [cargarDatosCompletos]);

    // Refrescar datos cuando regresa a esta vista (ej: después de iniciar un trámite)
    const location = useLocation();
    useEffect(() => {
        cargarDatosCompletos();
    }, [location, cargarDatosCompletos]);

    useEffect(() => {
        const cargarTiposTramite = async () => {
            try {
                const tipos = await getTipoTramites();
                setTiposTramite(Array.isArray(tipos) ? tipos : []);
            } catch (err) {
                console.error('Error cargando tipos de trámite:', err);
                setTiposTramite([]);
                setSnackbar({
                    open: true,
                    message: 'No se pudieron cargar las áreas de trámite',
                    severity: 'error'
                });
            }
        };

        if (dialogoSeleccionArea) {
            cargarTiposTramite();
        }
    }, [dialogoSeleccionArea]);


    useEffect(() => {
        const cargarProvincias = async () => {
            try {
                const data = await getProvincias();
                setProvincias(data);
            } catch (err) {
                console.error('Error cargando provincias:', err);
            }
        };
        cargarProvincias();
    }, []);

    const actualizarDomicilio = (index, cambios) =>
        setDomicilios(prev => prev.map((d, i) => i === index ? { ...d, ...cambios } : d));

    const handleDomicilioProvinciaChange = async (index, provinciaId) => {
        actualizarDomicilio(index, {
            _provinciaId: provinciaId,
            _divisionId: '',
            _divisiones: [],
            _localidades: [],
            localidad: { id: '', localidad: '', provincia: { id: provinciaId } }
        });
        if (provinciaId) {
            try {
                const [divs, locs] = await Promise.all([
                    getDivisionesPorProvincia(provinciaId),
                    getLocalidadesPorProvincia(provinciaId)
                ]);
                actualizarDomicilio(index, { _divisiones: divs, _localidades: locs });
            } catch { actualizarDomicilio(index, { _divisiones: [], _localidades: [] }); }
        }
    };

    const handleDomicilioDivisionChange = async (index, divisionId) => {
        actualizarDomicilio(index, {
            _divisionId: divisionId,
            _localidades: [],
            localidad: { ...domicilios[index].localidad, id: '' }
        });
        if (divisionId) {
            try {
                const locs = await getLocalidadesPorDivision(divisionId);
                actualizarDomicilio(index, { _localidades: locs });
            } catch { actualizarDomicilio(index, { _localidades: [] }); }
        }
    };

    const handleDomicilioLocalidadChange = (index, newValue) => {
        actualizarDomicilio(index, {
            localidad: newValue || { id: '', localidad: '', provincia: { id: domicilios[index]._provinciaId } },
            ...(newValue?.division ? { _divisionId: newValue.division.id } : {})
        });
    };

    const handleDomicilioCampoChange = (index, field, value) => {
        actualizarDomicilio(index, {
            [field]: (field === 'altura' || field === 'piso') ? (parseInt(value) || '') : value
        });
    };

    const agregarDomicilio = () => setDomicilios(prev => [...prev, domicilioVacio()]);
    const eliminarDomicilio = (index) => setDomicilios(prev => prev.filter((_, i) => i !== index));

    const actualizarHijo = (index, cambios) =>
        setHijos(prev => prev.map((h, i) => (i === index ? { ...h, ...cambios } : h)));
    const agregarHijo = () => setHijos(prev => [...prev, hijoVacio()]);
    const eliminarHijo = (index) => setHijos(prev => prev.filter((_, i) => i !== index));

    useEffect(() => {
        const cargarRefs = async () => {
            try {
                const res = await DatosMaestrosService.getReferencias();
                setReferenciasDisponibles(res.data);
            } catch (e) { console.error(e); }
        };
        cargarRefs();
    }, []);

    const handleClaveChange = (field) => (e) => {
        const value = e.target.value;
        setCliente(prev => ({
            ...prev,
            clave: {
                ...(prev.clave ?? { idClave: null, claveAfip: '', claveSs: '', claveCidi: '' }),
                [field]: value
            }
        }));
    };

    // --- FUNCIONES NUEVAS PARA REVELAR CLAVES ---
    const abrirDialogoSeguridad = (e) => {
        e.stopPropagation(); // Evita que el acordeón se cierre/abra al hacer clic en el botón
        setDialogoSeguridad(true);
        setPasswordConfirm('');
        setErrorPassword('');
    };

    const confirmarRevelarClaves = async () => {
        if (!passwordConfirm) {
            setErrorPassword('Ingrese su contraseña');
            return;
        }
        try {
            // Llamamos al servicio pasando el CUIL
            const data = await revelarClaves(cliente.cuil, passwordConfirm);

            setClavesReales(data); // Guardamos las claves reales en el estado local

            // --- FIX AÑADIDO: Actualizar el estado principal del cliente ---
            // Esto permite que al entrar en modo edición, los inputs tengan el valor real
            setCliente(prev => ({
                ...prev,
                clave: {
                    ...prev.clave,
                    claveAfip: data.claveAfip,
                    claveSs: data.claveSs,
                    claveCidi: data.claveCidi
                }
            }));
            // -------------------------------------------------------------

            setDialogoSeguridad(false);
            setPasswordConfirm('');
            setSnackbar({ open: true, message: 'Claves desencriptadas correctamente', severity: 'success' });
        } catch (err) {
            console.error("Error al revelar:", err);
            // Mostrar mensaje específico si viene del backend (ej: "Contraseña incorrecta")
            const msg = err.response?.data?.message || err.response?.data || "Error de seguridad. Verifique su contraseña.";
            setErrorPassword(msg);
        }
    };

    // Helper para mostrar: Si tenemos la real, muestra real. Si no, muestra la del cliente (que vendrá con asteriscos)
    const getClaveValue = (campo) => {
        if (clavesReales && clavesReales[campo]) return clavesReales[campo];
        return cliente.clave?.[campo] || '';
    };
    // --------------------------------------------




    // Cargar niveles educativos
    useEffect(() => {
        const cargarNiveles = async () => {
            try {
                const data = await getNivelesEducativos();
                setNiveles(data);
            } catch (e) {
                console.error('Error al cargar niveles educativos', e);
            }
        };
        cargarNiveles();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'telefonoPropio') {
            const digits = value.replace(/\D/g, '').slice(0, 10);
            setCliente({ ...cliente, telefonoPropio: digits });
            return;
        }
        setCliente({ ...cliente, [name]: type === 'checkbox' ? checked : value });
    };

    // Guardar observación desde la nota sticky (sin necesidad de entrar en modo edición)
    const handleGuardarObservacion = async (nuevaObservacion) => {
        try {
            // Enviamos solo los campos que el backend necesita para modificar,
            // excluyendo tramites, contactos y regularidad que pueden causar problemas
            const { tramites, contactos, regularidad, ...clienteSinRelaciones } = cliente;

            const domiciliosValidos = domicilios
                .filter(d => d.calle?.trim() && d.localidad?.id)
                .map(limpiarDomicilioParaGuardar);

            const clienteParaGuardar = {
                ...clienteSinRelaciones,
                observacion: nuevaObservacion,
                domicilios: domiciliosValidos,
                domicilio: domiciliosValidos[0] || null,
                // No reenviamos hijos acá: hijos=null en el backend significa "no tocar la
                // lista" (ver ClienteService.modificarCliente). Antes se reenviaban y, al
                // recrearse con IDs nuevos, se perdían las actas de nacimiento ya adjuntadas.
                hijos: undefined
            };
            await modificarCliente(cuil, clienteParaGuardar);
            setCliente(prev => ({ ...prev, observacion: nuevaObservacion }));
            setSnackbar({ open: true, message: 'Observación actualizada con éxito', severity: 'success' });
            await cargarDatosCompletos();
        } catch (err) {
            console.error('Error al guardar observación:', err);
            if (err.response && err.response.status === 409) {
                setConflictDialogOpen(true);
            } else {
                const errorMessage = err.response?.data?.message || err.response?.data || 'Error al actualizar la observación';
                setSnackbar({ open: true, message: errorMessage, severity: 'error' });
            }
            throw err; // Re-throw para que NotaComentario sepa que falló
        }
    };

    const handleInputChange = (field, value) => {
        setCliente(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSave = async (confirmarEliminarHijos = false) => {
        // Validaciones
        if (!cliente.apellido || !cliente.apellido.trim()) {
            setSnackbar({ open: true, message: 'El apellido es obligatorio', severity: 'error' });
            return;
        }
        if (!cliente.nombre || !cliente.nombre.trim()) {
            setSnackbar({ open: true, message: 'El nombre es obligatorio', severity: 'error' });
            return;
        }

        // Validar que apellido y nombre solo contengan letras y espacios
        if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(cliente.apellido)) {
            setSnackbar({ open: true, message: 'El apellido solo puede contener letras', severity: 'error' });
            return;
        }
        if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(cliente.nombre)) {
            setSnackbar({ open: true, message: 'El nombre solo puede contener letras', severity: 'error' });
            return;
        }

        // Validar fecha de ingreso
        if (!cliente.fechaIngreso) {
            setSnackbar({ open: true, message: 'La fecha de ingreso es obligatoria', severity: 'error' });
            return;
        }

        // Validar que la fecha no sea futura
        const fechaIngreso = new Date(cliente.fechaIngreso);
        const hoy = new Date();
        if (fechaIngreso > hoy) {
            setSnackbar({ open: true, message: 'La fecha de ingreso no puede ser futura', severity: 'error' });
            return;
        }

        // Validar email si está presente
        if (cliente.mail && cliente.mail.trim()) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(cliente.mail)) {
                setSnackbar({ open: true, message: 'El email no tiene un formato válido', severity: 'error' });
                return;
            }
        }

        // Validar teléfono si está presente
        if (cliente.telefonoPropio && !isTelefonoCordobaValido(cliente.telefonoPropio)) {
            setSnackbar({ open: true, message: 'El teléfono debe tener formato 351XXXXXXX (10 dígitos)', severity: 'error' });
            return;
        }

        for (let i = 0; i < contactos.length; i++) {
            const contacto = contactos[i];
            const tieneDatos = contacto.relacion?.trim() || contacto.nroTelefono?.trim() || contacto.nombre?.trim();
            if (!tieneDatos) {
                continue;
            }

            if (!isTelefonoCordobaValido(contacto.nroTelefono)) {
                setSnackbar({
                    open: true,
                    message: `El contacto ${i + 1} debe tener formato 351XXXXXXX (10 dígitos)`,
                    severity: 'error'
                });
                return;
            }
        }

        let domicilioIncompleto = false;
        for (let i = 0; i < domicilios.length; i++) {
            const dom = domicilios[i];
            const tieneCalle = (dom.calle || '').trim();
            const tieneLocalidad = dom.localidad?.id;
            const tieneAlgo = tieneCalle || dom.altura || tieneLocalidad || dom.piso || dom.departamento || (dom.barrio || '').trim();
            if (tieneAlgo && (!tieneCalle || !tieneLocalidad)) {
                domicilioIncompleto = true;
                setSnackbar({
                    open: true,
                    message: `El domicilio ${i + 1} requiere calle y localidad.`,
                    severity: 'warning'
                });
                return;
            }
        }

        // Validar aportes si existen
        if (cliente.aportes && cliente.aportes.length > 0) {
            for (let i = 0; i < cliente.aportes.length; i++) {
                const aporte = cliente.aportes[i];
                if (!aporte.fechaAporte) {
                    setSnackbar({ open: true, message: `El aporte ${i + 1} no tiene fecha`, severity: 'error' });
                    return;
                }
                // Validar que la fecha de aporte no sea futura
                const fechaAporte = new Date(aporte.fechaAporte);
                if (fechaAporte > hoy) {
                    setSnackbar({ open: true, message: `El aporte ${i + 1} no puede tener fecha futura`, severity: 'error' });
                    return;
                }
            }
        }

        try {
            const domiciliosValidos = domicilios
                .filter(d => d.calle?.trim() && d.localidad?.id)
                .map(limpiarDomicilioParaGuardar);

            // Se envían todas las filas, aunque estén vacías: "Agregar hijo" sin llenar nada es
            // el flujo real del estudio para dejar constancia de la cantidad de hijos cuando
            // todavía no tienen sus datos (nombre, fecha de nacimiento, AUH/CUD). El backend
            // además ignora esto si el género no es FEMENINO (los vacía sin pedir confirmación).

            // Excluimos tramites/contactos/regularidad: el backend no los lee en este endpoint
            // (los contactos se manejan por su propio servicio), así que solo son ruido en el payload.
            const { tramites, contactos, regularidad, ...clienteSinRelaciones } = cliente;

            await modificarCliente(cuil, {
                ...clienteSinRelaciones,
                telefonoPropio: normalizeTelefonoForStorage(cliente.telefonoPropio),
                domicilios: domiciliosValidos,
                domicilio: domiciliosValidos[0] || null,
                hijos,
                confirmarEliminarHijos
            });

            // Manejo de contactos (Múltiples)
            let erroresContactos = [];
            for (const contacto of contactos) {
                const tieneDatos = contacto.relacion?.trim() || contacto.nroTelefono?.trim() || contacto.nombre?.trim();

                if (tieneDatos) {
                    if (contacto.id) {
                        try {
                            // FIX: Al modificar, evitamos enviar cuilCliente para no triggerear la búsqueda/actualización del cliente padre innecesariamente, lo cual puede fallar
                            const datosUpdate = {
                                nombre: contacto.nombre,
                                relacion: contacto.relacion,
                                nroTelefono: normalizeTelefonoForStorage(contacto.nroTelefono)
                            };
                            await modificarContacto(contacto.id, datosUpdate);
                        } catch (err) {
                            console.error(`Error modificando contacto ${contacto.id}:`, err);
                            const msgError = err.response?.data?.message || err.response?.data || err.message || 'Error desconocido';
                            erroresContactos.push(`Contacto ${contacto.nombre || ''}: ${msgError}`);
                        }
                    } else {
                        try {
                            const nuevoContacto = {
                                ...contacto,
                                cuilCliente: cliente.cuil,
                                nroTelefono: normalizeTelefonoForStorage(contacto.nroTelefono)
                            };
                            await crearContacto(nuevoContacto);
                        } catch (err) {
                            console.error('Error creando nuevo contacto:', err);
                            const msgError = err.response?.data?.message || err.response?.data || err.message || 'Error desconocido';
                            erroresContactos.push(`Nuevo contacto ${contacto.nombre || ''}: ${msgError}`);
                        }
                    }
                }
            }

            setEditMode(false);
            setSnackbar({ open: true, message: 'Cliente actualizado con éxito', severity: 'success' });

            if (erroresContactos.length > 0) {
                 // Mejoramos la visualización de los errores uniéndolos con saltos de línea si es necesario
                 setSnackbar({ open: true, message: `Hubo errores al guardar contactos: ${erroresContactos.join(' | ')}`, severity: 'warning' });
            } else {
                 setSnackbar({ open: true, message: 'Cliente actualizado con éxito', severity: 'success' });
            }

            // --- RECARGA AUTOMÁTICA DE DATOS ---
            await cargarDatosCompletos();

        } catch (err) {
            console.error('Error al guardar cliente:', err);

            // --- CONFIRMACIÓN DE ELIMINACIÓN DE HIJOS (género deja de ser FEMENINO) ---
            if (err.response && err.response.status === 409 && err.response.data?.requiereConfirmacion) {
                setDialogoConfirmarEliminarHijos({
                    open: true,
                    hijos: err.response.data.hijos || [],
                    mensaje: err.response.data.mensaje || ''
                });
            // --- MANEJO DE CONCURRENCIA (ERROR 409) ---
            } else if (err.response && err.response.status === 409) {
                // Abrimos el Diálogo de Material UI
                setConflictDialogOpen(true);
            } else {
                const mensajeBackend = err.response?.data?.message || err.response?.data || '';
                const mensajeBackendTexto = String(mensajeBackend || '').toLowerCase();
                const pareceErrorDomicilio = domicilioIncompleto
                    || mensajeBackendTexto.includes('domicilio')
                    || mensajeBackendTexto.includes('localidad')
                    || mensajeBackendTexto.includes('error interno del servidor al modificar el cliente');

                const errorMessage = pareceErrorDomicilio
                    ? 'Para actualizar el domicilio debe completar Calle y Provincia/Localidad.'
                    : (err.response?.data?.message || err.response?.data || 'Error al modificar el cliente. Verifique los datos.');
                setSnackbar({ open: true, message: errorMessage, severity: 'error' });
            }
        }
    };

    const abrirDialogoEliminar = () => {
        setObservacionEliminar(cliente?.observacion || ''); // Precarga la observación si existe
        setPreviewBajaCargado(false);
        setDialogoEliminar({ open: true });
    };

    const cerrarDialogoEliminar = () => setDialogoEliminar({ open: false });

    const abrirDialogoReactivar = () => {
        setObservacionReactivar(cliente?.observacion || '');
        setDialogoReactivar({ open: true });
    };

    const cerrarDialogoReactivar = () => setDialogoReactivar({ open: false });

    // Formatea fecha de aaaa-mm-dd a dd-mm-aaaa
    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const partes = fecha.split('-');
        if (partes.length !== 3) return fecha;
        return `${partes[2]}-${partes[1]}-${partes[0]}`;
    };

    const formatearCuil = (cuil) => {
        if (!cuil) return '';
        const cuilStr = cuil.toString();
        if (cuilStr.length !== 11) return cuilStr;
        return `${cuilStr.slice(0, 2)}-${cuilStr.slice(2, 10)}-${cuilStr.slice(10)}`;
    };

    const confirmarEliminacion = async () => {
        try {
            // 1. Llama al servicio para eliminar el cliente
            await eliminarCliente(cuil, observacionEliminar);

            // 2. Cierra el diálogo de confirmación
            cerrarDialogoEliminar();

            // 3. AQUÍ ESTÁ LA LÍNEA CLAVE: Muestra el aviso de éxito
            setSnackbar({ open: true, message: 'Cliente dado de baja correctamente', severity: 'success' });

            // 4. Finalmente, navega de vuelta a la lista de clientes
            navigate('/clientes');
        } catch (err) {
            // Si hay un error, muestra un aviso de error
            setSnackbar({ open: true, message: 'Error al eliminar el cliente', severity: 'error' });
        }
    };

    const confirmarReactivacion = async () => {
        try {
            await reactivarCliente(cuil, observacionReactivar);
            cerrarDialogoReactivar();
            setSnackbar({ open: true, message: 'Cliente reactivado correctamente', severity: 'success' });
            // A diferencia de la baja, acá nos quedamos en la ficha: se recarga para que el botón
            // vuelva a mostrar "Dar de Baja" con el cliente ya activo.
            await cargarDatosCompletos();
        } catch (err) {
            setSnackbar({ open: true, message: 'Error al reactivar el cliente', severity: 'error' });
        }
    };

    const volver = () => navigate(-1);

    const imprimirCliente = async () => {
        setModoImpresion(true);
        // Ahora el PDF se exportará manualmente presionando el botón "Exportar a PDF"
        // dentro del componente ClienteImpresion, así que no abrimos window.print().
    };

    if (modoImpresion) {
        return (
            <ClienteImpresion
                cliente={cliente}
                contactos={contactos}
                clavesReales={clavesReales}
                onVolver={() => setModoImpresion(false)}
            />
        );
    }

    const statusColor = (nombreEstado) => {
        if (!nombreEstado) return '#9e9e9e'; // gris
        const lower = nombreEstado.toLowerCase();
        if (lower.includes('inic')) return '#4caf50'; // verde para iniciado
        if (lower.includes('pend')) return '#2196f3'; // azul para pendiente
        if (lower.includes('cerr') || lower.includes('finaliz') || lower.includes('complet')) return '#66bb6a'; // verde claro para completado
        if (lower.includes('rech') || lower.includes('cancel')) return '#f44336'; // rojo
        return '#1976d2'; // azul por defecto
    };

    // Versión translúcida del color de estado, para el fondo del badge. Los colores de
    // statusColor son hex de 6 dígitos, así que alcanza con anexarle el alfa.
    const tenue = (hex, alfa = '1f') => `${hex}${alfa}`;

    const esTramiteNoIniciado = (tramite) => {
        const estado = (tramite?.nombreEstadoActual || '').toLowerCase();
        const comentario = (tramite?.comentarios || '').toLowerCase();

        if (comentario.includes('[pendiente_inicio]') || comentario.includes('como pendiente al registrar cliente')) {
            return true;
        }

        if (estado.includes('pendiente') || estado.includes('no iniciado')) {
            return true;
        }

        return false;
    };

    const abrirTramiteSegunTipo = (tramite) => {
        const nombreTipo = (tramite?.tipoTramite?.nombre || '').toLowerCase();

        if (esTramiteNoIniciado(tramite)) {
            if (nombreTipo.includes('art')) {
                navigate(`/art/tramites/iniciar-tramite/${cliente.cuil}`, {
                    state: {
                        cuil: cliente?.cuil,
                        pendingTramiteId: tramite.idTramite,
                        vieneDeOtroTramite: false
                    }
                });
                return;
            }

            if (nombreTipo.includes('rti') || nombreTipo.includes('general')) {
                navigate(`/rti/tramites/iniciar-tramite/${cliente.cuil}`, {
                    state: {
                        cuil: cliente?.cuil,
                        pendingTramiteId: tramite.idTramite,
                        vieneDeOtroTramite: false
                    }
                });
                return;
            }
        }

        navigate(rutaDetalleTramite(tramite));
    };

    const handleIniciarTramite = () => {
        setAreaSeleccionada('');
        setDialogoSeleccionArea(true);
    };

    const iniciarEdicionEtiqueta = (tramite) => {
        setEtiquetaEditId(tramite.idTramite);
        setEtiquetaDraft(tramite.etiqueta || '');
    };

    const cancelarEdicionEtiqueta = () => {
        setEtiquetaEditId(null);
        setEtiquetaDraft('');
    };

    const guardarEtiqueta = async (tramite) => {
        // Guard de reentrancia: al deshabilitar el campo mientras se guarda (más abajo,
        // disabled={guardandoEtiqueta}), el input pierde el foco y el navegador dispara su
        // propio onBlur, que llama de nuevo a esta función — la segunda request en paralelo
        // llega con la misma `version` y pierde la carrera contra el bloqueo optimista de
        // Hibernate en el backend (500: "Row was updated ... by another transaction").
        if (guardandoEtiqueta) return;

        const etiquetaNueva = etiquetaDraft.trim();
        if (!etiquetaNueva) {
            cancelarEdicionEtiqueta();
            return;
        }

        try {
            setGuardandoEtiqueta(true);
            await modificarTramite(tramite.idTramite, {
                etiqueta: etiquetaNueva,
                version: tramite.version
            });

            setCliente(prev => ({
                ...prev,
                tramites: (prev?.tramites || []).map(t =>
                    t.idTramite === tramite.idTramite ? { ...t, etiqueta: etiquetaNueva } : t
                )
            }));

            setSnackbar({ open: true, message: 'Etiqueta actualizada', severity: 'success' });
            cancelarEdicionEtiqueta();
        } catch (err) {
            console.error('Error al actualizar etiqueta:', err);
            const errorMessage = err.response?.data?.message || err.response?.data || 'No se pudo guardar la etiqueta.';
            setSnackbar({ open: true, message: errorMessage, severity: 'error' });
        } finally {
            setGuardandoEtiqueta(false);
        }
    };

    // Reajuste, Pensión, Jubilación, Reconocimiento y Ganancias agrupan varias "familias" de
    // trámite bajo el mismo tipoTramite (ver t.subtipoTramite, calculado en
    // ClienteService#toDto a partir de TramiteReajusteEntity.beneficio /
    // TramitePensionEntity.getModalidad() / TramiteJubilacionEntity.subtipo /
    // TramiteReconocimientoEntity.subtipo / TramiteGananciasEntity.beneficio). Antes la única
    // forma de distinguirlas en esta grilla era la etiqueta libre, que el estudio terminó
    // usando para eso en vez de para su propósito.
    const ETIQUETAS_SUBTIPO_TRAMITE = {
        reajuste: { JUBILACION: 'Jubilación', PENSION: 'Pensión' },
        pension: { DIRECTA: 'Directa', DERIVADA: 'Derivada', HIJO_CON_DISCAPACIDAD: 'Hijo con discapacidad' },
        jubilacion: { ORDINARIA: 'Ordinaria', REGIMEN_DIFERENCIAL: 'Régimen Diferencial', CASAS_PARTICULARES: 'Casas Particulares' },
        reconocimiento: { COMUN: 'Común', SERVICIO_DOMESTICO: 'Servicio doméstico' },
        ganancias: { JUBILACION: 'Jubilación', PENSION: 'Pensión' },
        // Amparo por mora ante ANSES (V239): el subtipo es POR QUÉ TRÁMITE se ampara, así que en la
        // tarjeta se lee "AMPARO · Jubilación ordinaria". La clave es 'amparoanses' (la que devuelve
        // metaTramite) y no 'amparo', que es la de Amparo PNC —ese no tiene subtipos—.
        amparoanses: {
            RTI: 'Jubilación por invalidez',
            JUBILACION: 'Jubilación ordinaria',
            PENSION_DIRECTA: 'Pensión directa',
            PENSION_DERIVADA: 'Pensión derivada',
            PNC: 'Pensión no contributiva',
            EXPEDIENTE_357: 'Expediente 357',
            REAJUSTE: 'Reajuste de haberes',
        },
    };
    const tituloConSubtipo = (nombreTipo, clave, subtipoTramite) => {
        const etiquetaSubtipo = ETIQUETAS_SUBTIPO_TRAMITE[clave]?.[subtipoTramite];
        return etiquetaSubtipo ? `${nombreTipo} · ${etiquetaSubtipo}` : nombreTipo;
    };

    // Trámites del cliente. Grilla de tarjetas con el mismo lenguaje visual que las pantallas de
    // inicio (ver TramitesCliente.css): ícono en cuadrado tintado, título, estado y flecha.
    const renderTramites = () => {
        const tramites = cliente?.tramites || [];
        const hayTramites = tramites.length > 0;

        return (
            <div className="tramites-section">
                <div className="tramites-header-row">
                    <h2 className="tramites-section-title">
                        <i className="bi bi-folder2-open" />
                        Trámites
                        {hayTramites && (
                            <span className="tramites-count">
                                {tramites.length} trámite{tramites.length !== 1 ? 's' : ''}
                            </span>
                        )}
                    </h2>
                </div>

                {/* Constancia de origen: las filas del Excel de las que salieron sus trámites. */}
                {cliente?.cuil && <FilasPlanillaCliente cuil={cliente.cuil} />}
                {/* Lo que el Excel tenía de este cliente en CARPETAS ELIMINADAS y ARCHIVO (V253). */}
                {cliente?.cuil && <PlanillaHistoricaCliente cuil={cliente.cuil} />}

                <div className="tramites-grid" role="list">
                    {!hayTramites && (
                        <div className="tramites-empty">
                            <i className="bi bi-folder-x" />
                            <p>Este cliente todavía no tiene trámites asociados.</p>
                        </div>
                    )}

                    {tramites.map((t) => {
                        const noIniciado = esTramiteNoIniciado(t);
                        const colorEstado = noIniciado ? '#9e9e9e' : statusColor(t.nombreEstadoActual);
                        const tipoTramiteNombre = t?.tipoTramite?.nombre || '';
                        const { clave, icono } = metaTramite(tipoTramiteNombre);
                        // Los genéricos se ven con su título, no como "Genérico" (oct-2026).
                        const tituloTramite = t?.titulo || tituloConSubtipo(tipoTramiteNombre, clave, t?.subtipoTramite);
                        const estadoLabel = noIniciado ? 'No iniciado' : (t.nombreEstadoActual || 'Sin estado');
                        const editando = etiquetaEditId === t.idTramite;

                        return (
                            <div
                                key={t.idTramite}
                                role="listitem"
                                className={`tramite-card tramite-card--${clave}${noIniciado ? ' tramite-card--pendiente' : ''}`}
                                tabIndex={0}
                                title={`${tituloTramite || 'Trámite'} · ${estadoLabel}`}
                                onClick={() => {
                                    if (editando) return;
                                    abrirTramiteSegunTipo(t);
                                }}
                                onKeyDown={(e) => {
                                    if (editando) return;
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        abrirTramiteSegunTipo(t);
                                    }
                                }}
                            >
                                <div className="tramite-card-head">
                                    <div className="tramite-card-icon">
                                        <i className={`bi ${noIniciado ? 'bi-hourglass' : icono}`} />
                                    </div>

                                    <div className="tramite-card-body">
                                        <h5 className="tramite-card-title">
                                            {tituloTramite || 'Tipo desconocido'}
                                        </h5>
                                        {t.esNulidad && (
                                            <span className="tramite-card-nulidad">
                                                <i className="bi bi-arrow-repeat" />
                                                Nulidad
                                            </span>
                                        )}
                                        <span
                                            className="tramite-card-estado"
                                            style={{ color: colorEstado, background: tenue(colorEstado) }}
                                        >
                                            <span className="tramite-card-estado-dot" />
                                            <span>{estadoLabel}</span>
                                        </span>
                                    </div>

                                    <i className="bi bi-arrow-right-short tramite-card-arrow" />
                                </div>

                                <div className="tramite-card-foot">
                                    {editando ? (
                                        <TextField
                                            value={etiquetaDraft}
                                            onChange={(e) => setEtiquetaDraft(e.target.value)}
                                            size="small"
                                            fullWidth
                                            autoFocus
                                            disabled={guardandoEtiqueta}
                                            placeholder="Escribí una etiqueta…"
                                            variant="outlined"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    fontSize: '0.78rem',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#fff'
                                                },
                                                '& .MuiOutlinedInput-input': { padding: '6px 10px' }
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onKeyDown={(e) => {
                                                e.stopPropagation();
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    guardarEtiqueta(t);
                                                }
                                                if (e.key === 'Escape') {
                                                    e.preventDefault();
                                                    cancelarEdicionEtiqueta();
                                                }
                                            }}
                                            onBlur={() => guardarEtiqueta(t)}
                                            inputProps={{ maxLength: 100 }}
                                        />
                                    ) : (
                                        <span
                                            role="button"
                                            tabIndex={0}
                                            className={`tramite-etiqueta${t.etiqueta ? '' : ' tramite-etiqueta--vacia'}`}
                                            title={t.etiqueta ? 'Editar etiqueta' : 'Agregar etiqueta'}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                iniciarEdicionEtiqueta(t);
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    iniciarEdicionEtiqueta(t);
                                                }
                                            }}
                                        >
                                            <i className={`bi ${t.etiqueta ? 'bi-tag-fill' : 'bi-plus-lg'}`} />
                                            {t.etiqueta || 'Agregar etiqueta'}
                                        </span>
                                    )}
                                </div>
                            </div>
                        );
                    })}

                    <div
                        role="button"
                        tabIndex={0}
                        className="tramite-card-nuevo"
                        onClick={handleIniciarTramite}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handleIniciarTramite();
                            }
                        }}
                    >
                        <i className="bi bi-plus-circle" />
                        <span>Iniciar trámite</span>
                    </div>
                </div>
            </div>
        );
    };

    const renderRegularidad = () => (
        <>
            {/* Si NO estamos en editMode, mostramos el componente visual unificado como en Tramites */}
            {!editMode && (
                <Stack spacing={3} sx={{ mt: '1rem', mb: '1rem' }}>
                    
                    <Accordion defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h6" sx={{ color: '#1e3a8a' }} fontWeight="bold">
                                Resumen de Aportes Registrados
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GestionAportes
                                aportes={cliente.aportes || []}
                                readOnly={true}
                                onNavigateHistorial={() => navigate('/herramientas/historial-laboral', { state: { prefilledCuil: cliente.cuil, buscarBorrador: true } })}
                            />
                        </AccordionDetails>
                    </Accordion>

                    {cliente?.cuil && <SeccionLey24476Cliente cuil={cliente.cuil} />}
                </Stack>
            )}

            {/* Si estamos en editMode, mostramos las herramientas de edición */}
            {editMode && (
                <Accordion defaultExpanded={editMode}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Box display="flex" alignItems="center" gap={1} width="100%">
                            <Typography variant="h6" sx={{ color: '#1e3a8a' }} fontWeight="bold">
                                Gestión de Aportes
                            </Typography>
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Stack spacing={3}>
                            {/* Estado de Aportante Actual */}
                            <Box>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={cliente.aportanteActual || false}
                                            onChange={(e) => handleInputChange('aportanteActual', e.target.checked)}
                                        />
                                    }
                                    label="Es Aportante Actual"
                                />
                            </Box>

                            {/* Campo de detalle de aporte */}
                            <TextField
                                label="Detalle / Observación aportes"
                                value={cliente.detalleAporte || ''}
                                onChange={(e) => handleInputChange('detalleAporte', e.target.value)}
                                fullWidth
                                multiline
                                rows={2}
                                helperText="Información adicional sobre la regularidad o aportes"
                            />

                            {/* Alerta de Historial Laboral */}
                            <Alert severity="info" sx={{ mt: 2 }}>
                                Para asegurar la integridad de los cálculos, los aportes se deben agregar y modificar utilizando la herramienta de Historial Laboral.
                                <br/>
                                <Button 
                                    variant="outlined" 
                                    size="small" 
                                    sx={{ mt: 1 }}
                                    onClick={() => navigate('/herramientas/historial-laboral', { state: { prefilledCuil: cliente.cuil, buscarBorrador: true } })}
                                >
                                    Ir a Historial Laboral
                                </Button>
                            </Alert>
                        </Stack>
                    </AccordionDetails>
                </Accordion>
            )}
        </>
    );


    // --- LÓGICA DE ELIMINACIÓN DE CONTACTOS ---
    const handleEliminarContacto = async (index, contacto) => {
        if (contacto.id) {
            // Si el contacto existe en la BD (tiene ID), preguntamos antes de borrar o lo marcamos para borrar inmediatamente
            const confirm = window.confirm(`¿Seguro que desea eliminar el contacto ${contacto.nombre || ''}?`);
            if (confirm) {
                try {
                    await eliminarContacto(contacto.id);
                    // Actualizamos la lista local removiendo el elemento
                    const nuevosContactos = contactos.filter((_, i) => i !== index);
                    setContactos(nuevosContactos);
                    setSnackbar({ open: true, message: 'Contacto eliminado correctamente', severity: 'success' });
                } catch (error) {
                    console.error("Error al eliminar contacto:", error);
                    setSnackbar({ open: true, message: 'Error al eliminar el contacto', severity: 'error' });
                }
            }
        } else {
            // Si es un contacto nuevo (solo en memoria local), simplemente lo removemos del array
            const nuevosContactos = contactos.filter((_, i) => i !== index);
            setContactos(nuevosContactos);
        }
    };

    const renderFormFields = () => (
        <Stack spacing={3} mt={2}>
            {renderTramites()}

            {/* El historial de visitas va debajo de los trámites: primero "qué le estamos
                haciendo", después "cómo llegó hasta acá". */}
            {cliente?.cuil && <HistorialTurnosCliente cuil={cliente.cuil} />}

            {cliente?.cuil && <TarjetaCobrosCliente cuil={cliente.cuil} />}

            {/* --- DATOS PERSONALES --- */}
            <Accordion defaultExpanded sx={accordionStyle}>
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#1e3a8a' }} />} sx={accordionSummaryStyle}>
                    <Typography variant="h6" sx={tituloSeccionStyle}>
                        <PersonIcon /> Datos Personales
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 3 }}>
                    <Stack spacing={3}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                {editMode ? (
                                    <TextField label="CUIL" name="cuil" value={formatearCuil(cliente.cuil)} fullWidth disabled variant="outlined" />
                                ) : (
                                    <DatoLectura label="CUIL" value={formatearCuil(cliente.cuil)} />
                                )}
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                {editMode ? (
                                    <TextField label="Apellido" name="apellido" value={cliente.apellido || ''} onChange={handleChange} fullWidth required />
                                ) : (
                                    <DatoLectura label="Apellido" value={cliente.apellido} />
                                )}
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                {editMode ? (
                                    <TextField label="Nombre" name="nombre" value={cliente.nombre || ''} onChange={handleChange} fullWidth required />
                                ) : (
                                    <DatoLectura label="Nombre" value={cliente.nombre} />
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {editMode ? (
                                    <TextField label="Fecha de Ingreso" name="fechaIngreso" type="date" value={cliente.fechaIngreso || ''} onChange={handleChange} fullWidth InputLabelProps={{ shrink: true }} />
                                ) : (
                                    <DatoLectura label="Fecha de Ingreso" value={formatearFecha(cliente.fechaIngreso)} />
                                )}
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                {editMode ? (
                                    <TextField label="Fecha de Nacimiento" name="fechaNacimiento" type="date" value={cliente.fechaNacimiento || ''} onChange={handleChange} fullWidth InputLabelProps={{ shrink: true }} />
                                ) : (
                                    <DatoLectura label="Fecha de Nacimiento" value={formatearFecha(cliente.fechaNacimiento)} />
                                )}
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                {editMode ? (
                                    <TextField label="Edad" value={edad || ''} disabled fullWidth />
                                ) : (
                                    <DatoLectura label="Edad" value={edad ? `${edad} años` : ''} />
                                )}
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                {editMode ? (
                                    <TextField
                                        label="Teléfono"
                                        name="telefonoPropio"
                                        value={cliente.telefonoPropio || ''}
                                        onChange={handleChange}
                                        fullWidth
                                        helperText="Ingresar 10 dígitos. Ejemplo: 3517151340"
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 10 }}
                                    />
                                ) : (
                                    <DatoLectura label="Teléfono" value={normalizeTelefonoForStorage(cliente.telefonoPropio) || '—'}/>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {editMode ? (
                                    <TextField label="Email" name="mail" value={cliente.mail || ''} onChange={handleChange} fullWidth required />
                                ) : (
                                    <DatoLectura label="Email" value={cliente.mail} />
                                )}
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                {editMode ? (
                                    <TextField label="Oficio / Actividad" name="oficio" value={cliente.oficio || ''} onChange={handleChange} fullWidth />
                                ) : (
                                    <DatoLectura label="Oficio / Actividad" value={cliente.oficio || 'No especificado'} />
                                )}
                            </Grid>
                        </Grid>

                        <Divider />

                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 700 }}>
                                <HomeIcon sx={{ fontSize: 18, mr: 1, verticalAlign: 'text-bottom' }} />
                                DOMICILIOS
                            </Typography>
                            {editMode && domicilios.length < 2 && (
                                <Button
                                    size="small"
                                    startIcon={<AddCircleOutlineIcon />}
                                    onClick={agregarDomicilio}
                                    variant="outlined"
                                    sx={{ borderRadius: 2 }}
                                >
                                    Agregar domicilio
                                </Button>
                            )}
                        </Box>

                        {domicilios.map((dom, idx) => (
                            <Box
                                key={idx}
                                sx={{
                                    mb: domicilios.length > 1 ? 2 : 0,
                                    ...(editMode ? {
                                        p: 2,
                                        border: '1px solid #e2e8f0',
                                        borderRadius: 2,
                                        position: 'relative'
                                    } : {})
                                }}
                            >
                                {editMode && domicilios.length > 1 && (
                                    <IconButton
                                        size="small"
                                        onClick={() => eliminarDomicilio(idx)}
                                        sx={{ position: 'absolute', top: 6, right: 6, color: 'error.main' }}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                )}
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600, mb: 1.5, display: 'block' }}>
                                    Domicilio {idx + 1}
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        {editMode ? (
                                            <TextField
                                                select
                                                label="Tipo de domicilio"
                                                value={dom.tipo || ''}
                                                onChange={(e) => handleDomicilioCampoChange(idx, 'tipo', e.target.value)}
                                                fullWidth
                                                helperText="Usado por la Carátula"
                                            >
                                                <MenuItem value=""><em>Sin especificar</em></MenuItem>
                                                <MenuItem value="DNI">Domicilio del DNI</MenuItem>
                                                <MenuItem value="REAL">Domicilio real</MenuItem>
                                                <MenuItem value="OTRO">Otro</MenuItem>
                                            </TextField>
                                        ) : (
                                            <DatoLectura label="Tipo de domicilio" value={
                                                ({ DNI: 'Domicilio del DNI', REAL: 'Domicilio real', OTRO: 'Otro' })[dom.tipo] || 'Sin especificar'
                                            } />
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        {editMode ? (
                                            <TextField
                                                select
                                                label="Provincia"
                                                value={dom._provinciaId || ''}
                                                onChange={(e) => handleDomicilioProvinciaChange(idx, Number(e.target.value))}
                                                fullWidth
                                                sx={{ minWidth: '200px' }}
                                            >
                                                <MenuItem value="">Seleccionar</MenuItem>
                                                {provincias.map(p => (
                                                    <MenuItem key={p.id} value={p.id}>{p.nombre}</MenuItem>
                                                ))}
                                            </TextField>
                                        ) : (
                                            <DatoLectura label="Provincia" value={dom.localidad?.provincia?.nombre} />
                                        )}
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        {editMode ? (
                                            <TextField
                                                select
                                                label="Departamento / Partido"
                                                value={dom._divisionId || ''}
                                                onChange={(e) => handleDomicilioDivisionChange(idx, Number(e.target.value))}
                                                fullWidth
                                                sx={{ minWidth: '200px' }}
                                                disabled={!dom._divisiones?.length}
                                            >
                                                <MenuItem value="">Seleccionar</MenuItem>
                                                {(dom._divisiones || []).map(d => (
                                                    <MenuItem key={d.id} value={d.id}>{d.nombre}</MenuItem>
                                                ))}
                                            </TextField>
                                        ) : (
                                            <DatoLectura label="Departamento / Partido" value={dom.localidad?.division?.nombre} />
                                        )}
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        {editMode ? (
                                            <Autocomplete
                                                disablePortal
                                                options={dom._localidades || []}
                                                getOptionLabel={(option) => (option.localidad || option.nombre || "")}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                value={(dom._localidades || []).find(l => l.id === dom.localidad?.id) || null}
                                                onChange={(e, v) => handleDomicilioLocalidadChange(idx, v)}
                                                disabled={!dom._localidades?.length}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Localidad" fullWidth sx={{ minWidth: '200px' }} variant="outlined" />
                                                )}
                                                noOptionsText="Sin resultados"
                                            />
                                        ) : (
                                            <DatoLectura label="Localidad" value={dom.localidad?.nombre || dom.localidad?.localidad} />
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} sx={{ mt: 2 }}>
                                    <Grid item xs={12} sm={6}>
                                        {editMode ? (
                                            <TextField
                                                label="Barrio"
                                                value={dom.barrio || ''}
                                                onChange={(e) => handleDomicilioCampoChange(idx, 'barrio', e.target.value)}
                                                fullWidth
                                            />
                                        ) : (
                                            <DatoLectura label="Barrio" value={dom.barrio} />
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        {editMode ? (
                                            <TextField
                                                label="Calle"
                                                value={dom.calle || ''}
                                                onChange={(e) => handleDomicilioCampoChange(idx, 'calle', e.target.value)}
                                                fullWidth
                                            />
                                        ) : (
                                            <DatoLectura label="Calle" value={dom.calle} />
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} sx={{ mt: 2 }}>
                                    <Grid item xs={12} sm={4}>
                                        {editMode ? (
                                            <TextField
                                                label="Altura"
                                                type="number"
                                                value={dom.altura || ''}
                                                onChange={(e) => handleDomicilioCampoChange(idx, 'altura', e.target.value)}
                                                fullWidth
                                            />
                                        ) : (
                                            <DatoLectura label="Altura" value={dom.altura} />
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        {editMode ? (
                                            <TextField
                                                label="Piso"
                                                value={dom.piso || ''}
                                                onChange={(e) => handleDomicilioCampoChange(idx, 'piso', e.target.value)}
                                                fullWidth
                                            />
                                        ) : (
                                            <DatoLectura label="Piso" value={dom.piso} />
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        {editMode ? (
                                            <TextField
                                                label="Dpto"
                                                value={dom.departamento || ''}
                                                onChange={(e) => handleDomicilioCampoChange(idx, 'departamento', e.target.value)}
                                                fullWidth
                                            />
                                        ) : (
                                            <DatoLectura label="Dpto" value={dom.departamento} />
                                        )}
                                    </Grid>
                                </Grid>
                            </Box>
                        ))}

                        <Divider />

                        <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 700, mb: 1 }}>
                            <SchoolIcon sx={{ fontSize: 18, mr: 1, verticalAlign: 'text-bottom' }} />
                            OTROS DATOS
                        </Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                {editMode ? (
                                    <TextField
                                        select
                                        label="Nivel Educativo"
                                        value={cliente.nivelEducativo?.id || ''}
                                        onChange={(e) => {
                                            const nivelSeleccionado = niveles.find(n => n.id === parseInt(e.target.value));
                                            setCliente({ ...cliente, nivelEducativo: nivelSeleccionado });
                                        }}
                                        fullWidth
                                        sx={{ minWidth: '300px' }}
                                    >
                                        {niveles.map((nivel) => (
                                            <MenuItem key={nivel.id} value={nivel.id}>{nivel.nombre}</MenuItem>
                                        ))}
                                    </TextField>
                                ) : (
                                    <DatoLectura label="Nivel Educativo" value={cliente.nivelEducativo?.nombre} />
                                )}
                            </Grid>

                            <Grid item xs={6} sm={3}>
                                {editMode ? (
                                    <FormControlLabel
                                        control={<Checkbox checked={cliente.dosDoce || false} onChange={handleChange} name="dosDoce" />}
                                        label="Artículo 212"
                                    />
                                ) : (
                                    <DatoLectura
                                        label="Artículo 212"
                                        value={cliente.dosDoce ? 'SÍ' : 'NO'}
                                        icon={cliente.dosDoce ? <CheckCircleIcon color="success" fontSize="small"/> : <CancelIcon color="error" fontSize="small"/>}
                                    />
                                )}
                            </Grid>
                        </Grid>

                    </Stack>
                </AccordionDetails>
            </Accordion>

            {/* --- GÉNERO, HIJOS Y OBRA SOCIAL --- */}
            <Accordion sx={accordionStyle}>
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#1e3a8a' }} />} sx={accordionSummaryStyle}>
                    <Typography variant="h6" sx={tituloSeccionStyle}>
                        <PersonIcon /> Género, Hijos y Obra Social
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 3 }}>
                    <Stack spacing={2}>
                        <Grid container spacing={2}>
                            {/* MUI v7: el ancho se declara con size={{...}}. Las props item/xs/sm
                                del API viejo (hoy GridLegacy) se ignoran y el item colapsa al
                                ancho del contenido, dejando el select ilegible. */}
                            <Grid size={{ xs: 12, sm: 6 }}>
                                {editMode ? (
                                    <TextField
                                        select
                                        label="Género"
                                        value={cliente.genero || ''}
                                        onChange={(e) => setCliente({ ...cliente, genero: e.target.value })}
                                        fullWidth
                                    >
                                        <MenuItem value=""><em>Sin especificar</em></MenuItem>
                                        <MenuItem value="FEMENINO">Femenino</MenuItem>
                                        <MenuItem value="MASCULINO">Masculino</MenuItem>
                                        <MenuItem value="OTRO">Otro</MenuItem>
                                    </TextField>
                                ) : (
                                    <DatoLectura label="Género" value={
                                        cliente.genero === 'FEMENINO' ? 'Femenino'
                                            : cliente.genero === 'MASCULINO' ? 'Masculino'
                                            : cliente.genero === 'OTRO' ? 'Otro'
                                            : 'Sin especificar'
                                    } />
                                )}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                {editMode ? (
                                    <TextField
                                        select
                                        label="Estado civil"
                                        value={cliente.estadoCivil || ''}
                                        onChange={(e) => setCliente({ ...cliente, estadoCivil: e.target.value })}
                                        fullWidth
                                    >
                                        <MenuItem value=""><em>Sin especificar</em></MenuItem>
                                        <MenuItem value="SOLTERO">Soltero/a</MenuItem>
                                        <MenuItem value="CASADO">Casado/a</MenuItem>
                                        <MenuItem value="DIVORCIADO">Divorciado/a</MenuItem>
                                        <MenuItem value="VIUDO">Viudo/a</MenuItem>
                                        <MenuItem value="SEPARADO">Separado/a</MenuItem>
                                        <MenuItem value="CONCUBINATO">Concubinato</MenuItem>
                                    </TextField>
                                ) : (
                                    <DatoLectura label="Estado civil" value={
                                        ({ SOLTERO: 'Soltero/a', CASADO: 'Casado/a', DIVORCIADO: 'Divorciado/a', VIUDO: 'Viudo/a', SEPARADO: 'Separado/a', CONCUBINATO: 'Concubinato' })[cliente.estadoCivil] || 'Sin especificar'
                                    } />
                                )}
                            </Grid>
                            {(cliente.estadoCivil === 'CASADO' || cliente.estadoCivil === 'CONCUBINATO') && (
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    {editMode ? (
                                        <TextField
                                            label="Nombre del cónyuge"
                                            value={cliente.conyugeNombre || ''}
                                            onChange={(e) => setCliente({ ...cliente, conyugeNombre: e.target.value })}
                                            fullWidth
                                        />
                                    ) : (
                                        <DatoLectura label="Cónyuge" value={cliente.conyugeNombre || 'Sin especificar'} />
                                    )}
                                </Grid>
                            )}
                        </Grid>

                        {cliente.genero === 'FEMENINO' && (
                            <Box>
                                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                    <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 700 }}>
                                        <PersonIcon sx={{ fontSize: 18, mr: 1, verticalAlign: 'text-bottom' }} />
                                        HIJOS
                                    </Typography>
                                    {hijos.length > 0 && (
                                        <Chip
                                            size="small"
                                            label={`${hijos.length} ${hijos.length === 1 ? 'hijo' : 'hijos'}`}
                                            sx={{ fontWeight: 600 }}
                                        />
                                    )}
                                </Stack>
                                <Stack spacing={2}>
                                    {hijos.length === 0 && !editMode && (
                                        <Alert severity="info" variant="outlined">Sin hijos cargados.</Alert>
                                    )}
                                    {hijos.map((hijo, idx) => (
                                        <Paper
                                            key={idx}
                                            variant="outlined"
                                            sx={{ p: 2, borderRadius: 3, borderColor: '#e2e8f0', bgcolor: editMode ? '#fff' : '#f8fafc', position: 'relative' }}
                                        >
                                            {editMode ? (
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={5}>
                                                        <TextField
                                                            label="Nombre"
                                                            value={hijo.nombre || ''}
                                                            onChange={(e) => actualizarHijo(idx, { nombre: e.target.value })}
                                                            fullWidth size="small"
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <TextField
                                                            label="Fecha de nacimiento"
                                                            type="date"
                                                            value={hijo.fechaNacimiento || ''}
                                                            onChange={(e) => actualizarHijo(idx, { fechaNacimiento: e.target.value })}
                                                            fullWidth size="small"
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={3}>
                                                        <DatoLectura label="Edad" value={calcularEdad(hijo.fechaNacimiento)} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Stack direction="row" flexWrap="wrap">
                                                            <FormControlLabel control={<Checkbox checked={!!hijo.tieneAuh} onChange={(e) => actualizarHijo(idx, { tieneAuh: e.target.checked })} />} label="AUH" />
                                                            <FormControlLabel control={<Checkbox checked={!!hijo.tieneCud} onChange={(e) => actualizarHijo(idx, { tieneCud: e.target.checked })} />} label="CUD" />
                                                            <FormControlLabel control={<Checkbox checked={!!hijo.esAdoptado} onChange={(e) => actualizarHijo(idx, { esAdoptado: e.target.checked })} />} label="Adoptado/a" />
                                                        </Stack>
                                                    </Grid>
                                                </Grid>
                                            ) : (
                                                <Grid container spacing={2} alignItems="center">
                                                    <Grid item xs={12} sm={4}>
                                                        <Typography variant="subtitle2" color="text.secondary">Nombre</Typography>
                                                        <Typography variant="body1" fontWeight={500}>{hijo.nombre || '—'}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6} sm={2}>
                                                        <Typography variant="subtitle2" color="text.secondary">Edad</Typography>
                                                        <Typography variant="body1" fontWeight={500}>{calcularEdad(hijo.fechaNacimiento) || '—'}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6} sm={2}>
                                                        <Typography variant="subtitle2" color="text.secondary">AUH</Typography>
                                                        <Typography variant="body1" fontWeight={500}>{hijo.tieneAuh ? 'Sí' : 'No'}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6} sm={2}>
                                                        <Typography variant="subtitle2" color="text.secondary">CUD</Typography>
                                                        <Typography variant="body1" fontWeight={500}>{hijo.tieneCud ? 'Sí' : 'No'}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6} sm={2}>
                                                        <Typography variant="subtitle2" color="text.secondary">Adoptado/a</Typography>
                                                        <Typography variant="body1" fontWeight={500}>{hijo.esAdoptado ? 'Sí' : 'No'}</Typography>
                                                    </Grid>
                                                </Grid>
                                            )}
                                            {editMode && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => eliminarHijo(idx)}
                                                    sx={{ position: 'absolute', top: 8, right: 8, color: 'error.main' }}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </Paper>
                                    ))}
                                    {editMode && (
                                        <Button
                                            variant="outlined"
                                            startIcon={<AddCircleOutlineIcon />}
                                            onClick={agregarHijo}
                                            sx={{ alignSelf: 'flex-start' }}
                                        >
                                            Agregar hijo
                                        </Button>
                                    )}
                                </Stack>
                            </Box>
                        )}

                        <Divider />

                        <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 700, mb: 1 }}>
                            OBRA SOCIAL
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                {editMode ? (
                                    <FormControlLabel
                                        control={<Checkbox checked={!!cliente.tieneObraSocial} onChange={(e) => setCliente({ ...cliente, tieneObraSocial: e.target.checked })} />}
                                        label="Tiene obra social"
                                    />
                                ) : (
                                    <DatoLectura
                                        label="Tiene obra social"
                                        value={cliente.tieneObraSocial ? 'SÍ' : 'NO'}
                                        icon={cliente.tieneObraSocial ? <CheckCircleIcon color="success" fontSize="small"/> : <CancelIcon color="error" fontSize="small"/>}
                                    />
                                )}
                            </Grid>
                            {(cliente.tieneObraSocial || editMode) && (
                                <>
                                    <Grid item xs={12} sm={4}>
                                        {editMode ? (
                                            <TextField
                                                label="Nombre de la obra social"
                                                value={cliente.nombreObraSocial || ''}
                                                onChange={(e) => setCliente({ ...cliente, nombreObraSocial: e.target.value })}
                                                fullWidth
                                            />
                                        ) : (
                                            <DatoLectura label="Nombre de la obra social" value={cliente.nombreObraSocial} />
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        {editMode ? (
                                            <FormControlLabel
                                                control={<Checkbox checked={!!cliente.mantieneObraSocialPostJubilacion} onChange={(e) => setCliente({ ...cliente, mantieneObraSocialPostJubilacion: e.target.checked })} />}
                                                label="¿La mantiene post-jubilación?"
                                            />
                                        ) : (
                                            <DatoLectura
                                                label="Mantiene post-jubilación"
                                                value={cliente.mantieneObraSocialPostJubilacion ? 'SÍ' : 'NO'}
                                            />
                                        )}
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Stack>
                </AccordionDetails>
            </Accordion>

            {/* --- CONTACTOS --- */}
            <Accordion sx={accordionStyle}>
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#1e3a8a' }} />} sx={accordionSummaryStyle}>
                    <Typography variant="h6" sx={tituloSeccionStyle}>
                        <ContactPhoneIcon /> Contactos Adicionales
                    </Typography>
                </AccordionSummary>

                <AccordionDetails sx={{ p: 3 }}>
                    <Stack spacing={2}>
                        {contactos.length === 0 && !editMode && (
                            <Alert severity="info" variant="outlined">No hay contactos adicionales registrados.</Alert>
                        )}

                        {contactos.map((contactoItem, index) => (
                            <Paper
                                key={index}
                                variant="outlined"
                                sx={{
                                    p: 2,
                                    borderRadius: 3,
                                    borderColor: '#e2e8f0',
                                    bgcolor: editMode ? '#fff' : '#f8fafc',
                                    position: 'relative'
                                }}
                            >
                                {editMode ? (
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                label="Nombre (Opcional)"
                                                value={contactoItem.nombre || ''}
                                                onChange={(e) => {
                                                    const updatedContactos = [...contactos];
                                                    updatedContactos[index] = { ...updatedContactos[index], nombre: e.target.value };
                                                    setContactos(updatedContactos);
                                                }}
                                                fullWidth size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                select
                                                label="Relación"
                                                value={contactoItem.relacion || ''}
                                                onChange={(e) => {
                                                    const updatedContactos = [...contactos];
                                                    updatedContactos[index] = { ...updatedContactos[index], relacion: e.target.value };
                                                    setContactos(updatedContactos);
                                                }}
                                                fullWidth size="small"
                                            >
                                                <MenuItem value="">Seleccionar</MenuItem>
                                                <MenuItem value="Hijo/a">Hijo/a</MenuItem>
                                                <MenuItem value="Esposo/a">Esposo/a</MenuItem>
                                                <MenuItem value="Nieto/a">Nieto/a</MenuItem>
                                                <MenuItem value="Hermano/a">Hermano/a</MenuItem>
                                                <MenuItem value="Padre/Madre">Padre/Madre</MenuItem>
                                                <MenuItem value="Amigo/a">Amigo/a</MenuItem>
                                                <MenuItem value="Otro">Otro</MenuItem>
                                            </TextField>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                label="Teléfono"
                                                value={contactoItem.nroTelefono || ''}
                                                onChange={(e) => {
                                                    const updatedContactos = [...contactos];
                                                    const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                    updatedContactos[index] = {
                                                        ...updatedContactos[index],
                                                        nroTelefono: digits
                                                    };
                                                    setContactos(updatedContactos);
                                                }}
                                                fullWidth size="small"
                                                helperText="Ingresar 10 dígitos. Ejemplo: 3517151340"
                                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 10 }}
                                            />
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={12} sm={4}>
                                            <Typography variant="subtitle2" color="text.secondary">Nombre</Typography>
                                            <Typography variant="body1" fontWeight={500}>{contactoItem.nombre || '—'}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Typography variant="subtitle2" color="text.secondary">Relación</Typography>
                                            <Typography variant="body1" fontWeight={500}>{contactoItem.relacion || '—'}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Typography variant="subtitle2" color="text.secondary">Teléfono</Typography>
                                            <Typography variant="body1" fontWeight={500}>{normalizeTelefonoForStorage(contactoItem.nroTelefono) || '—'}</Typography>
                                        </Grid>
                                    </Grid>
                                )}
                                {editMode && (
                                    <IconButton
                                        size="small"
                                        onClick={() => handleEliminarContacto(index, contactoItem)}
                                        sx={{
                                            position: 'absolute',
                                            top: 8,
                                            right: 8,
                                            color: 'error.main',
                                            '&:hover': {
                                                color: 'error.dark',
                                                bgcolor: 'error.lighter'
                                            }
                                        }}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </Paper>
                        ))}
                        {editMode && (
                            <Button
                                variant="outlined"
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={() => setContactos([...contactos, { nroTelefono: '', relacion: '', nombre: '', cuilCliente: cliente.cuil }])}
                                sx={{ alignSelf: 'flex-start', mt: 1 }}
                            >
                                Agregar Contacto
                            </Button>
                        )}
                    </Stack>
                </AccordionDetails>
            </Accordion>

            {/* --- CLAVES --- */}
            <Accordion sx={accordionStyle}>
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#1e3a8a' }} />} sx={accordionSummaryStyle}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" pr={2}>
                        <Typography variant="h6" sx={tituloSeccionStyle}>
                            <LockIcon /> Claves Fiscales
                        </Typography>
                        {!editMode && (
                            <Box onClick={(e) => e.stopPropagation()}>
                                {!clavesReales ? (
                                    <Tooltip title="Revelar claves ocultas">
                                        <IconButton
                                            color="primary"
                                            size="small"
                                            onClick={abrirDialogoSeguridad}
                                            sx={{ mr: 1 }}
                                        >
                                            <VisibilityIcon />
                                        </IconButton>
                                    </Tooltip>
                                ) : (
                                    <Chip
                                        icon={<LockIcon fontSize="small" />}
                                        label="Desencriptado"
                                        color="success"
                                        size="small"
                                        variant="filled"
                                    />
                                )}
                            </Box>
                        )}
                    </Box>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 3 }}>
                    <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}>
                        {editMode ? (
                            <>
                                <TextField label="Clave AFIP" value={cliente.clave?.claveAfip ?? ''} onChange={handleClaveChange('claveAfip')} fullWidth />
                                <TextField label="Clave SS" value={cliente.clave?.claveSs ?? ''} onChange={handleClaveChange('claveSs')} fullWidth />
                                <TextField label="Clave CIDI" value={cliente.clave?.claveCidi ?? ''} onChange={handleClaveChange('claveCidi')} fullWidth />
                            </>
                        ) : (
                            <>
                                <Box flex={1}>
                                    <DatoLectura label="Clave AFIP" value={getClaveValue('claveAfip')} icon={<LockIcon fontSize="small" />} />
                                </Box>
                                <Box flex={1}>
                                    <DatoLectura label="Clave SS" value={getClaveValue('claveSs')} icon={<LockIcon fontSize="small" />} />
                                </Box>
                                <Box flex={1}>
                                    <DatoLectura label="Clave CIDI" value={getClaveValue('claveCidi')} icon={<LockIcon fontSize="small" />} />
                                </Box>
                            </>
                        )}
                    </Stack>
                </AccordionDetails>
            </Accordion>

            <Accordion sx={accordionStyle}>
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#1e3a8a' }} />} sx={accordionSummaryStyle}>
                    <Typography variant="h6" sx={tituloSeccionStyle}>
                        <InfoIcon/> Referencia
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 3 }}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            {editMode ? (
                                <SelectorReferenciaCliente
                                    value={cliente}
                                    onChange={(cambios) => setCliente(prev => ({ ...prev, ...cambios }))}
                                    referenciasDisponibles={referenciasDisponibles}
                                    onCrearNuevaReferencia={(nuevaRef) => {
                                        setReferenciasDisponibles(prev => [...prev, nuevaRef]);
                                        setCliente(prev => ({ ...prev, referencia: nuevaRef.nombre, idReferencia: nuevaRef.id }));
                                    }}
                                    excluirCuil={cliente.cuil}
                                />
                            ) : (
                                <Stack spacing={1}>
                                    <DatoLectura
                                        label={cliente.referenciaHeredada ? 'Referencia (heredada)' : 'Referencia'}
                                        value={cliente.referencia}
                                    />
                                    {/* Trazabilidad completa: quién lo trajo y si esa persona es
                                        cliente del estudio. Cuando no lo es no hay referencia de
                                        origen que heredar y la referencia queda en OTRO CLIENTE. */}
                                    {cliente.nombreClienteReferente && (
                                        <Box sx={{ fontSize: '0.85rem', color: '#0369a1' }}>
                                            <i className="bi bi-person-check-fill me-1" />
                                            Traído por <strong>{cliente.nombreClienteReferente}</strong>, cliente del estudio
                                            {cliente.cuilClienteReferente && ` (CUIL ${cliente.cuilClienteReferente})`}
                                        </Box>
                                    )}
                                    {cliente.nombreReferenteExterno && (
                                        <Box sx={{ fontSize: '0.85rem', color: '#0369a1' }}>
                                            <i className="bi bi-person-plus-fill me-1" />
                                            Traído por <strong>{cliente.nombreReferenteExterno}</strong>, que no está registrado en el sistema.
                                        </Box>
                                    )}
                                </Stack>
                            )}
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>


            {renderRegularidad()}

        </Stack>
    );

    return (
        <div className="d-flex justify-content-center pb-5">
            <Paper
                id="detalle-cliente-pdf"
                elevation={0}
                className="rounded-4"
                sx={{
                    p: { xs: 2, md: 4 },
                    width: '100%',
                    backgroundColor: '#ffffff',
                    border: '1px solid #e0e0e0',
                    boxShadow: 'var(--shadow-md)',
                    position: 'relative',
                    overflow: 'hidden'
                }}
            >
                    {/* --- Cabecera con título y botones principales --- */}
                    <Box mb={2} display="flex" justifyContent="space-between" alignItems="flex-start">
                        <Box>
                            <Typography variant="h4" color="primary" fontWeight={600}>
                                Detalle del Cliente
                            </Typography>
                            {/* Mismo encabezado de persona que el detalle de cada trámite: apellido y nombre + acceso a WhatsApp. */}
                            {cliente?.apellido && cliente?.nombre && (
                                <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                                    <h5 className="text-secondary fw-semibold mb-0">
                                        <PersonSearchIcon fontSize="small" className="me-1 mb-1" />
                                        {apellidoNombre(cliente.apellido, cliente.nombre)}
                                    </h5>
                                    {cliente.telefonoPropio && (
                                        <WhatsAppHeaderButton
                                            phone={cliente.telefonoPropio}
                                            clientName={`${cliente.nombre} ${cliente.apellido}`}
                                            onClick={() => window.dispatchEvent(
                                                new CustomEvent('openAdminSidebar', { detail: { tab: 'whatsapp' } })
                                            )}
                                        />
                                    )}
                                </div>
                            )}
                        </Box>
                        <Box display="flex" gap={1} mt={0.5}>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<PictureAsPdfIcon />}
                                onClick={imprimirCliente}
                            >
                                Ficha PDF
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<LinkIcon />}
                                onClick={() => setModalAnsesAbierto(true)}
                                sx={{
                                    background: 'var(--primary)',
                                    '&:hover': {
                                        background: 'var(--primary)',
                                    },
                                }}
                            >
                                ANSES
                            </Button>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={volver}
                            >
                                Volver
                            </Button>
                        </Box>
                    </Box>

                    {/* --- Nota Sticky de Observación --- */}
                    {!loading && !error && cliente && (
                        <NotaComentario
                            valor={cliente.observacion || ''}
                            onGuardar={handleGuardarObservacion}
                            label="Observación del Cliente"
                            color="yellow"
                            nombreUsuario={user?.nombre || ''}
                        />
                    )}

                    {/* --- Contenido principal (Formulario o Loader) --- */}
                    {loading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight={150}><CircularProgress /></Box>
                    ) : error ? (
                        <Alert severity="error">{error}</Alert>
                    ) : cliente ? (
                        renderFormFields() // Esta función renderiza los campos del cliente
                    ) : (
                        <Alert severity="info">No se encontró información del cliente.</Alert>
                    )}

                    {/* --- Botones de acción inferiores --- */}
                    <Box mt={3} display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
                        {cliente && (
                            <>
                                {editMode ? (
                                    <>
                                        <Button variant="outlined" color="secondary" onClick={async () => { setEditMode(false); await cargarDatosCompletos(); }}>Cancelar</Button>
                                        <Button variant="contained" color="primary" onClick={() => handleSave()}>Guardar Cambios</Button>
                                    </>
                                ) : (
                                    <>
                                        {cliente.activo === false ? (
                                            <>
                                                <Button variant="contained" color="success" startIcon={<RestoreIcon />} onClick={abrirDialogoReactivar}>
                                                    Dar de Alta
                                                </Button>
                                                {(user?.rol === 'ADMIN' || user?.rol === 'PROGRAMADOR') && (
                                                    <Button
                                                        variant="outlined"
                                                        color="error"
                                                        startIcon={<DeleteForeverIcon />}
                                                        onClick={() => setModalEliminarDefinitivo(true)}
                                                    >
                                                        Eliminar definitivamente
                                                    </Button>
                                                )}
                                            </>
                                        ) : (
                                            <Button variant="contained" color="error" startIcon={<DeleteIcon />} onClick={abrirDialogoEliminar}>
                                                Dar de Baja
                                            </Button>
                                        )}
                                        <Button variant="contained" color="primary" onClick={() => setEditMode(true)}>
                                            Modificar
                                        </Button>
                                    </>
                                )}
                            </>
                        )}
                    </Box>
                </Paper>

            {/* Borrado definitivo del cliente (solo si ya está inactivo). */}
            <ModalEliminarDefinitivo
                open={modalEliminarDefinitivo}
                onClose={() => setModalEliminarDefinitivo(false)}
                tipo="CLIENTE"
                identificador={cliente?.cuil}
                onEliminado={() => navigate('/clientes', { replace: true })}
            />

            {/* --- DIÁLOGO DE SEGURIDAD (PASSWORD PARA REVELAR CLAVES) --- */}
            <Dialog open={dialogoSeguridad} onClose={() => setDialogoSeguridad(false)}>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LockIcon color="warning" />
                    Seguridad Requerida
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        Para visualizar las claves fiscales, por favor confirme su contraseña. Esta acción quedará registrada en la auditoría del sistema.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="password"
                        label="Contraseña"
                        type="password"
                        fullWidth
                        variant="outlined"
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                        error={!!errorPassword}
                        helperText={errorPassword}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') confirmarRevelarClaves();
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogoSeguridad(false)} color="inherit">
                        Cancelar
                    </Button>
                    <Button onClick={confirmarRevelarClaves} variant="contained" color="primary">
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* --- CONECTAR ANSES: mismo modal que "Agregar Cliente" en Seguimiento de Expedientes,
                 pero con el cliente de esta ficha preseleccionado (sin paso de búsqueda). --- */}
            {cliente && (
                <ModalAgregarClienteAnses
                    open={modalAnsesAbierto}
                    onClose={() => setModalAnsesAbierto(false)}
                    onAgregar={handleClienteAgregadoAnses}
                    onRefrescar={() => {}}
                    clientePreseleccionado={{
                        cuil: cliente.cuil,
                        cuilRaw: cliente.cuil,
                        nombre: `${cliente.apellido || ''} ${cliente.nombre || ''}`.trim(),
                    }}
                />
            )}

            {/* --- DIÁLOGO DE CONFIRMACIÓN DE BAJA --- */}
            <Dialog open={dialogoEliminar.open} onClose={cerrarDialogoEliminar} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ backgroundColor: '#f5f5f5', color: '#333', fontWeight: 'bold' }}>
                    ⚠️ Confirmar Baja de Cliente
                </DialogTitle>
                <DialogContent dividers sx={{ backgroundColor: '#ffffff', padding: 3 }}>
                    {cliente && (
                        <div className="d-flex flex-column gap-3">
                            <div className="p-3 rounded-3 shadow-sm" style={{ backgroundColor: '#f9f9f9' }}>
                                <p className="mb-1"><strong>CUIL:</strong> {formatearCuil(cliente.cuil)}</p>
                                <p className="mb-1"><strong>Nombre:</strong> {apellidoNombre(cliente.apellido, cliente.nombre)}</p>
                                <p className="mb-0"><strong>Fecha Ingreso:</strong> {formatearFecha(cliente.fechaIngreso)}</p>
                            </div>

                            <PreviewCancelacionBajaCliente cuil={cliente.cuil} onCargado={() => setPreviewBajaCargado(true)} />

                            <div className="mt-2">
                                <label htmlFor="observacionEliminar" className="form-label fw-semibold">
                                    Ingrese una observación para la baja:
                                </label>
                                <textarea
                                    id="observacionEliminar"
                                    className="form-control"
                                    rows="4"
                                    value={observacionEliminar}
                                    onChange={(e) => setObservacionEliminar(e.target.value)}
                                    style={{ resize: 'none', borderRadius: '0.5rem', borderColor: '#ced4da' }}
                                />
                            </div>
                        </div>
                    )}
                </DialogContent>
                <DialogActions sx={{ padding: 2, justifyContent: 'space-between' }}>
                    <button className="btn btn-outline-secondary" onClick={cerrarDialogoEliminar}>
                        Cancelar
                    </button>
                    <button className="btn btn-danger" onClick={confirmarEliminacion} disabled={!previewBajaCargado}>
                        Confirmar Baja
                    </button>
                </DialogActions>
            </Dialog>

            {/* --- DIÁLOGO DE CONFIRMACIÓN DE ALTA --- */}
            <Dialog open={dialogoReactivar.open} onClose={cerrarDialogoReactivar} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ backgroundColor: '#f5f5f5', color: '#333', fontWeight: 'bold' }}>
                    ✅ Confirmar Alta de Cliente
                </DialogTitle>
                <DialogContent dividers sx={{ backgroundColor: '#ffffff', padding: 3 }}>
                    {cliente && (
                        <div className="d-flex flex-column gap-3">
                            <div className="p-3 rounded-3 shadow-sm" style={{ backgroundColor: '#f9f9f9' }}>
                                <p className="mb-1"><strong>CUIL:</strong> {formatearCuil(cliente.cuil)}</p>
                                <p className="mb-0"><strong>Nombre:</strong> {apellidoNombre(cliente.apellido, cliente.nombre)}</p>
                            </div>

                            <div className="mt-2">
                                <label htmlFor="observacionReactivar" className="form-label fw-semibold">
                                    Ingrese una observación para la reactivación:
                                </label>
                                <textarea
                                    id="observacionReactivar"
                                    className="form-control"
                                    rows="4"
                                    value={observacionReactivar}
                                    onChange={(e) => setObservacionReactivar(e.target.value)}
                                    style={{ resize: 'none', borderRadius: '0.5rem', borderColor: '#ced4da' }}
                                />
                            </div>
                        </div>
                    )}
                </DialogContent>
                <DialogActions sx={{ padding: 2, justifyContent: 'space-between' }}>
                    <button className="btn btn-outline-secondary" onClick={cerrarDialogoReactivar}>
                        Cancelar
                    </button>
                    <button className="btn btn-success" onClick={confirmarReactivacion}>
                        Confirmar Alta
                    </button>
                </DialogActions>
            </Dialog>

            {/* --- Diálogo de Conflicto de Concurrencia (Material UI) --- */}
            <Dialog
                open={conflictDialogOpen}
                onClose={() => {}} // Bloqueamos el cierre manual para obligar a leer
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent sx={{ textAlign: 'center', p: 3 }}>
                    <WarningIcon sx={{ fontSize: 60, color: '#ed6c02', mb: 2 }} />
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#ed6c02', fontWeight: 'bold' }}>
                        Datos Desactualizados
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Otro usuario ha modificado la información de este cliente recientemente.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Para proteger la integridad de los datos, la página se actualizará automáticamente con la versión más reciente.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={async () => {
                            setConflictDialogOpen(false); // Cerrar modal
                            setEditMode(false);           // Salir modo edición
                            await cargarDatosCompletos(); // Recargar datos
                        }}
                    >
                        Entendido, actualizar datos
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Confirmación de eliminación de hijos (el género deja de ser FEMENINO) */}
            <Dialog
                open={dialogoConfirmarEliminarHijos.open}
                onClose={() => setDialogoConfirmarEliminarHijos({ open: false, hijos: [], mensaje: '' })}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 'bold', color: '#b45309', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <WarningIcon sx={{ color: '#f59e0b' }} /> Confirmar cambio de género
                </DialogTitle>
                <DialogContent dividers>
                    <Typography sx={{ mb: 2 }}>{dialogoConfirmarEliminarHijos.mensaje}</Typography>
                    <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>Se eliminarán los siguientes hijos (y sus actas de nacimiento en cualquier trámite):</Typography>
                    <ul style={{ marginTop: 0 }}>
                        {dialogoConfirmarEliminarHijos.hijos.map((nombre, idx) => (
                            <li key={idx}>{nombre}</li>
                        ))}
                    </ul>
                    <Typography variant="body2" color="text.secondary">Esta acción no se puede deshacer. ¿Confirmás continuar?</Typography>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={() => setDialogoConfirmarEliminarHijos({ open: false, hijos: [], mensaje: '' })} sx={{ textTransform: 'none' }}>
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="warning"
                        sx={{ textTransform: 'none' }}
                        onClick={() => {
                            setDialogoConfirmarEliminarHijos({ open: false, hijos: [], mensaje: '' });
                            handleSave(true);
                        }}
                    >
                        Sí, eliminar hijos y continuar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={dialogoSeleccionArea}
                onClose={() => setDialogoSeleccionArea(false)}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: '16px',
                        boxShadow: 'var(--shadow-lg)'
                    }
                }}
            >
                <DialogTitle sx={{ fontWeight: 'bold', color: '#1e40af', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <BookmarkIcon />
                    Seleccionar Área de Trámite
                </DialogTitle>
                <DialogContent dividers sx={{ pt: 3 }}>
                    <Typography sx={{ mb: 3 }}>
                        Por favor, seleccione el área para iniciar el trámite del cliente:
                    </Typography>
                    <Select
                        fullWidth
                        variant="outlined"
                        sx={{ borderRadius: '12px' }}
                        value={areaSeleccionada}
                        onChange={(e) => setAreaSeleccionada(e.target.value)}
                    >
                        {tiposTramite
                            .filter((tipo) => (tipo.nombre || '').trim().toUpperCase() !== 'RECEPCION')
                            .map((tipo) => (
                                <MenuItem key={tipo.idTipoTramite} value={tipo.idTipoTramite}>
                                    {tipo.nombre}
                                </MenuItem>
                            ))}
                    </Select>
                </DialogContent>
                <DialogActions sx={{ p: 3, pt: 0, gap: 1 }}>
                    <Button
                        onClick={() => setDialogoSeleccionArea(false)}
                        sx={{ borderRadius: '20px', color: '#6b7280', textTransform: 'none', fontWeight: 600 }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        disabled={!areaSeleccionada}
                        onClick={() => {
                            // Resolvemos por nombre (no por ID: los IDs de tipotramite son volátiles,
                            // V44/V75/V108/V111 los reasignan), igual que hace el backend.
                            const tipoSeleccionado = tiposTramite.find(
                                (t) => Number(t.idTipoTramite) === Number(areaSeleccionada)
                            );
                            const nombre = (tipoSeleccionado?.nombre || '').trim().toUpperCase();

                            setDialogoSeleccionArea(false);

                            if (nombre === 'RTI') {
                                navigate(`/rti/tramites/iniciar-tramite/${cliente.cuil}`, {
                                    state: { cuil: cliente?.cuil, vieneDeOtroTramite: false }
                                });
                                return;
                            }
                            if (nombre === 'ART') {
                                navigate(`/art/tramites/iniciar-tramite/${cliente.cuil}`, {
                                    state: { cuil: cliente?.cuil, vieneDeOtroTramite: false }
                                });
                                return;
                            }
                            const destino = rutaIniciarTramite(nombre, cliente.cuil);
                            if (destino) {
                                navigate(destino);
                                return;
                            }
                            setDialogoNoDisponible(true);
                        }}
                        sx={{
                            borderRadius: '20px',
                            textTransform: 'none',
                            background: 'var(--primary)',
                            boxShadow: 'var(--shadow-md)',
                            '&:hover': {
                                background: 'var(--primary)',
                                boxShadow: 'var(--shadow-md)'
                            }
                        }}
                    >
                        Continuar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={dialogoNoDisponible}
                onClose={() => setDialogoNoDisponible(false)}
                PaperProps={{
                    sx: {
                        borderRadius: '16px',
                        boxShadow: 'var(--shadow-lg)'
                    }
                }}
            >
                <DialogTitle sx={{ fontWeight: 'bold', color: '#d32f2f', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <WarningIcon color="error" />
                    Funcionalidad en desarrollo
                </DialogTitle>
                <DialogContent dividers sx={{ pt: 3 }}>
                    <Typography>
                        El inicio de trámites para esta área aún no se encuentra disponible en el sistema.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ p: 3, pt: 0, gap: 1 }}>
                    <Button
                        variant="contained"
                        onClick={() => setDialogoNoDisponible(false)}
                        sx={{
                            borderRadius: '20px',
                            textTransform: 'none',
                            background: 'var(--primary)',
                            boxShadow: 'var(--shadow-md)',
                            '&:hover': {
                                background: 'var(--primary)',
                                boxShadow: 'var(--shadow-md)'
                            }
                        }}
                    >
                        Entendido
                    </Button>
                </DialogActions>
            </Dialog>

            {/* --- Snackbar para notificaciones --- */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert severity={snackbar.severity}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default VistaDetalladaCliente;
